import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="confirma-borrado"
// En el formulario de una ficha, «Borrado» es un radio más del estado: pide confirmación al guardar
// si se acaba de elegir (la ficha deja de verse en la web), como el «Borrar producto» del menú de
// la ficha. Guardar una ficha que ya estaba borrada no pregunta.
export default class extends Controller {
  // `borrado`: el valor del estado «Borrado» (`Opinable::Estados::NO_PUBLICADO`).
  static values = { mensaje: String, borrado: String }

  connect () {
    this.estadoInicial = this.estadoMarcado()
  }

  confirma (event) {
    const borrando = this.estadoMarcado() === this.borradoValue && this.estadoInicial !== this.borradoValue
    if (borrando && !window.confirm(this.mensajeValue)) event.preventDefault()
  }

  estadoMarcado () {
    return this.element.querySelector('input[type=radio][name$="[estado]"]:checked')?.value
  }
}
